// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1jZu8","tab":"Tabs_tab__1NgBY","tabActive":"Tabs_tabActive__3NAT-"};